import { TbMinus, TbPlus } from "react-icons/tb";
import styled from "styled-components";

const Button = styled.button<{ size: "lg" | "md" | "sm", buttonType: "primary" | "primary-light" | "primary-white" | "secondary" | "secondary-white" | "cancel", radius?: string, textColor?: string, bg?: string }>`
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: ${props => props.radius ? props.radius : '0.25rem'};
    cursor: pointer;
    font-family: "Geist";
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    white-space: nowrap;
    ${props => props.bg
        ? `background: ${props.bg} !important;`
        : "background: transparent;"}

    &:disabled{
        opacity: 0.4;
    }

    ${props => props.size === "lg" && `
        padding: 12px 27px;
        font-size: .9rem;
        line-height: 1.5;
        border-radius: ${props.radius ? props.radius : '9px'};
    `}

    ${props => props.size === "md" && `
        padding: 9px 30px;
        font-size: .87rem;
        line-height: 1.5;
        border-radius: ${props.radius ? props.radius : '9px'};
    `}

    ${props => props.size === "sm" && `
        padding: 5px 10px;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: ${props.radius ? props.radius : '0.2rem'};
    `}

    ${props => props.buttonType === "primary" && `
        color: ${props.textColor || '#fff'};
        border: none;
        background: #323C60;

        &:hover{
            color: ${props.textColor || '#fff'};
            background: #323C60;
        }
    `}

    ${props => props.buttonType === "primary-light" && `
        color: #0b0b0b;
        border: none;
        background: #f0cfcf;
    `}

    ${props => props.buttonType === "cancel" && `
        color: #F24822;
        background-color: #FAF4F2;
        border-color: transparent;

        &:hover{
            color: #F24822;
            background-color: #ffe6dd;
            border-color: transparent;
        }
    `}

    ${props => props.buttonType === "primary-white" && `
        color: ${props.theme.primary};
        background-color: white;
        border-color: white;

        &:hover{
            color: #fff;
            background-color: transparent;
            border-color: white;
        }
    `}

    ${props => props.buttonType === "secondary" && `
        color: #323C60;
        background: transparent;
        border-color: #323C60;

        &:hover{
            color: #fff;
            background-color: #323C60;
            border-color: #323C60;
        }
    `}

    ${props => props.buttonType === "secondary-white" && `
        color: white;
        background: transparent;
        border-color: white;

        &:hover{
            color: #323C60;
            background-color: white;
            border-color: white;
        }
    `}
`

export default Button

export const AddFieldButton: React.FC<{ onClick?: () => void }> = ({ onClick }) => {
    return <button onClick={onClick} className="p-1 text-[#03D86C] bg-[#03D86C]/40 rounded-[7px]">
        <TbPlus />
    </button>
}

export const RemoveFieldButton: React.FC<{ onClick?: () => void }> = ({ onClick }) => {
    return <button onClick={onClick} className="p-1 text-[#F13E3F] bg-[#F13E3F]/40 rounded-[7px]">
        <TbMinus />
    </button>
}

export const ShadowWrap = styled.div`
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0px 4px 4px 0px #00000008;
    border: 1px solid #CCCCCC4D;
`

export const OptionButton = styled.button`
    width: 100%;
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0px 4px 4px 0px #00000008;
    border: 1px solid #CCCCCC4D;
`

export const CenteredModalWrapper = styled.div`
//   min-width: 600px;
//   max-width: 600px;
    height: 100%;
`